const ITEMS = [
  "Conformité",
  "RGPD",
  "AI Act",
  "LCB-FT",
  "KYC",
  "Droit des affaires",
  "Gouvernance",
  "Gestion des risques",
  "Sérénité",
  "Performance",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-3xl font-medium italic text-ivory/70 sm:text-4xl">
          {item}
        </span>
        <span className="text-lg text-gold" aria-hidden="true">
          ✦
        </span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-label="Valeurs et domaines clés"
    className="relative overflow-hidden border-y border-ink-line bg-ink-card/40 py-7"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
